var getResponseAndDataObject = function getResponseAndDataObject(response) {
  return response.json().then(function (data) {
    return {
      data: data,
      response: response
    };
  });
};

export default getResponseAndDataObject;